import { jsx as _jsx } from "react/jsx-runtime";
import { Page } from '@dixa/lib-shared-habla';
import { useEffect } from 'react';
import { waitMusicApi } from 'apis/waitMusic';
import { pubSub } from 'utils/pubSub';
import { Table } from '../table/table';
export const WaitMusicFiles = () => {
    const [getWaitMusic, { data, isFetching, isError }] = waitMusicApi.useLazyReadWaitMusicQuery();
    useEffect(() => {
        // subscribe to the ws event that says when the music file is ready to use,
        // so that we can then refresh the list of music files
        const unsubscribe = pubSub.subscribe('uploadWaitMusicResult', () => getWaitMusic());
        getWaitMusic();
        return () => unsubscribe();
    }, [getWaitMusic]);
    const numFiles = data === null || data === void 0 ? void 0 : data.data.wait_music.length;
    return (_jsx(Page.Section, Object.assign({ title: `${numFiles !== null && numFiles !== void 0 ? numFiles : 0} music file${numFiles === 1 ? '' : 's'}` }, { children: _jsx(Table, { type: "wait-music", data: data, retry: getWaitMusic, isLoading: isFetching, isError: isError }) })));
};
